import { LoadingButton, LoadingButtonProps } from "@mui/lab";

import { theme } from "../mui-customs/Theme";
import Typography from "./Typography";

const Button = ({ children, sx, ...props }: LoadingButtonProps) => {
  return (
    <LoadingButton
      variant="contained"
      sx={{
        width: "100%",
        maxWidth: { md: "327px" },
        py: "16px",
        display: "block",
        color: theme.whiteBg.WBG1,
        textTransform: "none",
        ...sx,
      }}
      {...props}
    >
      <Typography variant="btnMedium">{children}</Typography>
    </LoadingButton>
  );
};

export default Button;
